var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Hazardous component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconHazardous extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.4064 14.2483C14.6007 14.2958 14.768 14.419 14.871 14.5904L17.8544 19.552C18.0673 19.906 17.9537 20.3655 17.6005 20.5797C15.9123 21.6034 13.9758 22.1447 12.0014 22.1447C10.027 22.1447 8.09045 21.6034 6.40226 20.5797C6.04901 20.3655 5.93549 19.906 6.14836 19.552L9.13154 14.5904C9.23461 14.419 9.40189 14.2958 9.59619 14.2483C9.7905 14.2008 9.99572 14.2329 10.1663 14.3374C10.7188 14.6761 11.3535 14.8569 12.0014 14.8602C12.6493 14.8569 13.2839 14.6761 13.8363 14.3375C14.0068 14.2329 14.212 14.2008 14.4064 14.2483ZM10.0566 15.9628L7.8344 19.6588C9.1247 20.3056 10.5512 20.6447 12.0014 20.6447C13.4516 20.6447 14.878 20.3056 16.1683 19.6588L13.946 15.9629C13.3338 16.2214 12.6741 16.3574 12.0045 16.3602L11.9983 16.3602V16.3602C11.3286 16.3574 10.6689 16.2214 10.0566 15.9628Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.4903 7.78384C10.5464 7.59181 10.5233 7.38535 10.4264 7.21037L7.4419 2.23405C7.24173 1.87266 6.78699 1.74119 6.42486 1.94002C4.70723 3.04612 3.68024 4.04559 2.63218 5.76691C1.64498 7.47677 1.0834 9.30584 1.12582 11.2797C1.1347 11.6927 1.47591 12.0208 1.88896 12.0135L7.72011 12.0134C7.92011 12.0098 8.1104 11.9266 8.24869 11.782C8.38698 11.6375 8.46181 11.4437 8.45655 11.2438C8.4395 10.5959 8.62102 9.96522 8.94214 9.40253C9.26326 8.83983 9.53643 8.62976 10.1281 8.23296C10.3039 8.13755 10.4343 7.97586 10.4903 7.78384ZM6.96991 10.5211L2.6528 10.5211C2.7378 9.08029 3.21171 7.76547 3.9368 6.50957C4.66189 5.25368 5.31108 4.6425 6.54652 3.64974L8.78146 7.35612C7.68481 8.34172 7.24754 9.09826 6.96991 10.5211Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5097 7.78384C13.4536 7.59181 13.4767 7.38535 13.5736 7.21037L16.5581 2.23405C16.7583 1.87266 17.213 1.74119 17.5751 1.94002C19.2928 3.04612 20.3198 4.04559 21.3678 5.76691C22.355 7.47677 22.9166 9.30584 22.8742 11.2797C22.8653 11.6927 22.5241 12.0208 22.111 12.0135L16.2799 12.0134C16.0799 12.0098 15.8896 11.9266 15.7513 11.782C15.613 11.6375 15.5382 11.4437 15.5435 11.2438C15.5605 10.5959 15.379 9.96522 15.0579 9.40253C14.7367 8.83983 14.4636 8.62976 13.8719 8.23296C13.6961 8.13755 13.5657 7.97586 13.5097 7.78384ZM17.0301 10.5211L21.3472 10.5211C21.2622 9.08029 20.7883 7.76547 20.0632 6.50957C19.3381 5.25368 18.6889 4.6425 17.4535 3.64974L15.2185 7.35612C16.3152 8.34172 16.7525 9.09826 17.0301 10.5211Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5 11.2729C10.5 10.4445 11.1716 9.77289 12 9.77289C12.8284 9.77289 13.5 10.4445 13.5 11.2729C13.5 12.1013 12.8284 12.7729 12 12.7729C11.1716 12.7729 10.5 12.1013 10.5 11.2729Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconHazardous.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconHazardous.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconHazardous.prototype, "size", void 0);
if (customElements.get('cat-icon-hazardous') === undefined) {
    customElements.define('cat-icon-hazardous', BlocksIconHazardous);
}
